import {EligibleChannelsEndpointResponseSuccess} from '../../../generated/types';

export function fetchEligibleChannels(
  supportFetch: typeof fetch,
  entryPoint: string,
  audience: string,
): Promise<EligibleChannelsEndpointResponseSuccess> {
  return supportFetch(
    `/api/eligible-channels/${entryPoint}?audience=${audience}`,
  ).then((resp) => {
    if (resp.ok) {
      return resp.json();
    } else {
      return {channels: []};
    }
  });
}
